module.exports = __webpack_public_path__ + "img/icon42.7104c52f.png";